var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wg-grid__item",class:{
         ['wg-shadow__' + _vm.finalBoxShadow]: _vm.finalBoxShadow,
        ['wg-' + _vm.layoutPosition]: _vm.layoutPosition,
        ['wg-bg-color__' + _vm.finalBackgroundColor]: _vm.finalBackgroundColor,
        ['wg-border__' + _vm.borderLine]: _vm.borderLine,
        ['wg-border__box']: _vm.borderBox,
        ['wg-border__radius-' + _vm.originBorderRadius]: _vm.originBorderRadius,
        [_vm.className]: _vm.className,
    },style:(Object.assign(_vm.extraStyle, {
        margin: _vm.finalMargin,
        padding: _vm.finalPadding,
        borderRadius: _vm.borderRadius,
        backgroundColor: _vm.customBackgroundColor,
    }))},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }